import React from 'react'
import { Input, Label } from 'components';

import styles from './Text.scss';


const Text = (props) => {
	var customStyles = {}
	var classNames = styles.Text;
	if(props.align === 'right'){
		classNames = classNames+ ' ' + styles.isRight;
	}
	if(props.align === 'center'){
		classNames = classNames+ ' ' + styles.isCenter;
	}
	if(props.type === 'afterInput'){
		classNames = classNames+ ' ' + styles.isAfterInput;		
	}

	if(props.size === 'small'){
		classNames = classNames+ ' ' + styles.isSmall;		
	}

	if(props.size === 'middle'){
		classNames = classNames+ ' ' + styles.isMiddle;		
	}

	if(props.fontCut === 'light'){
		classNames = classNames+ ' ' + styles.isLight;			
	}

	if(props.color){
		customStyles = {color: props.color};		
	}

  	return (
      <div 
          className={classNames}
          style={customStyles}>
        {props.children}
      </div>
  )
}

export default Text



// WEBPACK FOOTER //
// ./src/components/atoms/Text/index.js